import script from "./HelpView.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpView.vue?vue&type=script&lang=ts&setup=true"

import "./HelpView.vue?vue&type=style&index=0&id=30f8a466&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f8a466"]])

export default __exports__